import { useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { hideLoader, showLoader } from "../../../../../store/actions";
import {
  setCurrentStep,
  storeAckNumber,
  getPersonalDetails,
  getKycDetails,
  getBankDetails,
  getNomineeList,
  getSchemeDetails,
  getFundChoices,
  storeSubscriberData,
} from "../../../../../store/actions/newSubscriber";
import { setACKNumber } from "../../Context/NewSubscriberAction";

const BUILD_URL = process.env.PUBLIC_URL;

const buttonStyle = {
  border: "1px solid #006DC0",
  color: "#006DC0",
  fontSize: "14px",
  fontWeight: 400,
};

const IS_DEV = process.env.PUBLIC_URL !== "/dit";

const SubscriberTable = ({ active, data }) => {
  return (
    <>
      {!!data && data.length > 0 ? (
        <TableData active={active} data={data} />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "OPenSans-SemiBold",
          }}
        >
          No data Found
        </div>
      )}
    </>
  );
};

export default SubscriberTable;

const TableData = ({ active, data }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { isAdditionalPurchaseEnabled } = useSelector(
    (state) => state.npsReducer
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const displayedData = data.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const clickHandler = async (AckNumber) => {
    if (active === "Pending Subscribers") {
      try {
        dispatch(showLoader());
        dispatch(setCurrentStep(1));
        dispatch(storeAckNumber(AckNumber));
        await dispatch(getFundChoices());
        await dispatch(getPersonalDetails({ AckNumber }));
        await dispatch(getKycDetails({ AckNumber }));
        //await dispatch(getFatcaDetails({ AckNumber }));
        await dispatch(getBankDetails({ AckNumber }));
        await dispatch(getNomineeList({ AckNumber }));
        await dispatch(getSchemeDetails({ AckNumber }));
        history.push(`/nps/AddSubs/new-reg`);
      } catch (error) {
        console.error(error);
        alert(error);
      } finally {
        dispatch(hideLoader());
      }
    }
  };

  const clickHandler2 = async (subscriber) => {
    if (active != "Pending Subscribers") {
      try {
        dispatch(showLoader());
        dispatch(setCurrentStep(1));
        dispatch(setACKNumber(subscriber.AckNumber));
        dispatch(storeSubscriberData(subscriber));
        // await dispatch(getFundChoices());
        // await dispatch(getPersonalDetails({ AckNumber }));
        // await dispatch(getKycDetails({ AckNumber }));
        // //await dispatch(getFatcaDetails({ AckNumber }));
        // await dispatch(getBankDetails({ AckNumber }));
        // await dispatch(getNomineeList({ AckNumber }));
        // await dispatch(getSchemeDetails({ AckNumber }));
        history.push(`/nps/additionalPurchase`, {
          AckNumber: subscriber.AckNumber,
          Pan: subscriber.pan,
        });
      } catch (error) {
        alert(error);
      } finally {
        dispatch(hideLoader());
      }
    }
  };
  return (
    <>
      <TableContainer>
        <Table style={{ border: "0px", background: "white" }}>
          <TableBody>
            {displayedData.map((_subscriber) => (
              <TableRow key={_subscriber.PAN}>
                <TableCell>
                  <div style={{ display: "flex" }}>
                    <img
                      alt="user"
                      src={`${BUILD_URL}/images/user.png`}
                      width="40"
                      height="40"
                      className="user-icon"
                    />
                    <span
                      className="investor-name mouse-pointer"
                      style={{
                        fontFamily: "OpenSans-SemiBold",
                        marginLeft: "10px",
                        marginTop: "0.5rem",
                      }}
                      onClick={() => {
                        if (IS_DEV) {
                          if (active != "Pending Subscribers") {
                            dispatch(storeSubscriberData(_subscriber));
                            history.push(`/nps/portfolio`);
                          }
                        }
                      }}
                    >
                      {active != "Pending Subscribers" ? (
                        <u>{_subscriber.SubscriberName}</u>
                      ) : (
                        <>{_subscriber.SubscriberName}</>
                      )}
                    </span>
                  </div>
                </TableCell>
                <TableCell>
                  <img
                    src={BUILD_URL + "/images/call_investors.svg"}
                    alt="phone-icon"
                    className="phone-icon"
                  />
                  {_subscriber.PhoneNumber}
                </TableCell>
                <TableCell>PAN : {_subscriber.PAN}</TableCell>
                {active != "Pending Subscribers" && (
                  <>
                    {!!_subscriber.PRAN && (
                      <TableCell>PRAN: {_subscriber.PRAN}</TableCell>
                    )}
                  </>
                )}

                <TableCell aria-disabled={true}>
                  {(!!_subscriber.PRAN && isAdditionalPurchaseEnabled) ||
                  process.env.PUBLIC_URL.includes("dit_uat_portal") ? (
                    <div className="mouse-pointer">
                      <Button
                        variant="outlined"
                        onClick={() => clickHandler2(_subscriber)}
                        style={buttonStyle}
                      >
                        Additional purchase
                      </Button>
                    </div>
                  ) : !!_subscriber.PRAN ? null : (
                    <div className="mouse-pointer">
                      <Button
                        variant="outlined"
                        onClick={() => clickHandler(_subscriber.AckNumber)}
                        style={buttonStyle}
                      >
                        Complete Registration
                      </Button>
                      {/* <span className="transaction-button">
                      <img
                        src={BUILD_URL + "/images/rupees_white.png"}
                        className="transction-action-icon"
                        alt="rupees-icon"
                      />
                      Complete Registration
                    </span> */}
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        colSpan={3}
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        // style={{ alignItems: "left" }}
      />
    </>
  );
};
